<script lang="ts" setup>
  import { MobileViewLayout } from '../../../shared/ui/mobile-view-layout';
  import { Spinner } from '../../../shared/ui/spinner';
</script>

<template>
  <MobileViewLayout justify="center">
    <Spinner />
  </MobileViewLayout>
</template>
